import type { Page } from "@/types";

export const pageRoutes: Partial<Record<Page, string>> = {
  overview: "/overview",
  delivery: "/delivery",
  clients: "/clients",
  instances: "/instances",
  schedule: "/schedule",
  servers: "/servers",
  gateway: "/gateway",
  scheme: "/scheme",
  install: "/install",
};

export function normalizeRoutePath(pathname: string) {
  return pathname.replace(/\/+$/, "") || "/";
}

export function getPageFromPath(pathname: string): Page {
  const normalized = normalizeRoutePath(pathname);
  if (normalized === "/") return "overview";
  const match = Object.entries(pageRoutes).find(([, route]) => route === normalized);
  return match ? (match[0] as Page) : "overview";
}

export function getPathForPage(page: Page) {
  return pageRoutes[page] || "/overview";
}
